import React from 'react';
import { Typography } from '../../index';

interface IPageLeadProps {
	icon: React.ReactNode;
	headline: string;
	description: string | React.ReactNode;
	narrow?: boolean;
}

export const PageLead = ({ icon, headline, description, narrow }: IPageLeadProps) => {
	return (
		<div className={`flex items-center flex-col ${narrow ? ' mb-5' : 'mb-5 md:mb-6'}`}>
			<span className="mb-2">{icon}</span>
			<Typography
				component="h1"
				variant="header"
				size="h2"
				color="title"
				className="mb-3 px-4 text-center md:px-0">
				{headline}
			</Typography>
			<Typography component="p" size="lg" color="text" className="px-3.5 text-center md:px-5.5">
				{description}
			</Typography>
		</div>
	);
};
